import React, { memo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { getLiteral } from 'utils/getLiteral';
import { errorToast } from 'utils/toast';
import { Text, Icon } from '@Sage/hoi-poi-ui';
import InputFileDecorator from '../../../../../decorators/InputFileDecorator';
import DropZone from '../../../../../components/DropZone';
import './styles.scss';

export const Shapes = {
    SQUARE: { border: '1px dashed #ddd', height: 125, width: 125 },
    CIRCLE: { border: '1px dashed #ddd', height: 125, width: 125, borderRadius: '50%' },
};

const propTypes = {
    type: PropTypes.object,
    src: PropTypes.string,
    onChange: PropTypes.func,
    onRemoveImage: PropTypes.func,
};

const ChangeButton = () => (
    <Text type="caption" className="fm-company-logo-image__change-btn">
        {getLiteral('label_change')}
    </Text>
);

const ChangeButtonInput = InputFileDecorator('image/*')(ChangeButton);

const LogoComponent = memo(({ type, src, onChange, onRemoveImage }) => {
    const [hover, setHover] = useState(false);

    const shape = type ?? Shapes.CIRCLE;
    const isCircle = shape === Shapes.CIRCLE || !!shape.borderRadius;

    const onDrop = useCallback(
        (droppedFiles) => {
            onChange(droppedFiles[0]);
            setHover(false);
        },
        [onChange],
    );

    const onDragEnter = useCallback(() => setHover(true), []);
    const onDragLeave = useCallback(() => setHover(false), []);

    const onRejected = useCallback(() => {
        errorToast({ text: getLiteral('error_wrong_format_image_supported') });
    }, []);

    return (
        <div className="fm-company-logo-image">
            <DropZone
                onDragEnter={onDragEnter}
                onDragLeave={onDragLeave}
                onDropRejected={onRejected}
                onDrop={onDrop}
                style={{ border: 'none', width: 125, height: 125, margin: '0 auto' }}
                accept="image/*"
            >
                <div
                    className={`fm-company-logo-image__shape${isCircle ? ' fm-company-logo-image__shape--circle' : ''}`}
                >
                    {src && <img className="fm-company-logo-image__img" src={src} alt="" />}
                    <ChangeButtonInput onChange={onChange} />
                </div>
                {hover && (
                    <div
                        className={`fm-company-logo-image__dropzone-overlay${isCircle ? ' fm-company-logo-image__dropzone-overlay--circle' : ''}`}
                    />
                )}
            </DropZone>
            {src && (
                <Icon
                    name="close"
                    onClick={onRemoveImage}
                    className="fm-company-logo-image__remove-icon"
                />
            )}
        </div>
    );
});

LogoComponent.propTypes = propTypes;

export const Logo = LogoComponent;
